/* THIS FILE IS GENERATED. DO NOT EDIT */

import { PropsFromComponent } from '@/types/component';
import ErrorBoundary from 'base/components/ErrorBoundary';
import LabradorVideoReels from 'base/components/labrador/VideoReels';

export const DynamicLabradorVideoReels: typeof LabradorVideoReels = (props) => {
    return <ErrorBoundary><LabradorVideoReels {...props} /></ErrorBoundary>;
}
export type DynamicLabradorVideoReelsProps = PropsFromComponent<typeof LabradorVideoReels>;
